import { render, staticRenderFns } from "./IngredientDescriptionField.vue?vue&type=template&id=142b5e5a&"
import script from "./IngredientDescriptionField.vue?vue&type=script&lang=js&"
export * from "./IngredientDescriptionField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports